<script lang="ts" setup>
import { ref } from "vue";
import mitt from "@/application/plugins/mitt";
import { ConfirmationModal } from "@/application/types";
import { useDisplay } from "vuetify";
import KBtn from "@/application/components/KBtn.vue";
import { useI18n } from "@/application/plugins/i18n";

const { t } = useI18n();
const { xs, sm } = useDisplay();

const data = ref<ConfirmationModal | null>(null);
const isConfirmActionLoading = ref(false);

mitt.on("confirm", (payload) => {
  data.value = payload;
});

const closeDialog = () => {
  data.value?.cancelAction?.();
  data.value = null;
};

const onConfirm = async () => {
  isConfirmActionLoading.value = true;

  try {
    await data.value?.confirmAction?.();
    closeDialog();
  } catch (error) {
    console.error(error);
  } finally {
    isConfirmActionLoading.value = false;
  }
};
</script>

<template>
  <VDialog
    :model-value="!!data"
    :width="460"
    persistent
    @update:model-value="closeDialog"
  >
    <VCard v-if="data">
      <VCardTitle class="text-wrap">
        <h4 class="text-title text-accent">
          {{ data.title ?? t("messages.areYouSure") }}
        </h4>
        <p class="text-body-2 text-emphasis mt-2">
          {{ data.body ?? t("messages.actionCantBeReverted") }}
        </p>
      </VCardTitle>

      <div class="pa-4">
        <VRow
          :class="{
            'flex-nowrap': sm,
          }"
          :style="xs ? 'flex-direction: column-reverse' : undefined"
          class="pb-6 mx-0 ga-2"
          justify="end"
        >
          <KBtn
            v-if="!data.noCancelAction"
            :text="data.cancelButtonText || t('actions.cancel')"
            border-color="transparent"
            responsive
            v-bind="{
              ...data?.style?.cancelBtnProps,
            }"
            @click="closeDialog"
          />

          <KBtn
            :loading="isConfirmActionLoading"
            :text="data.confirmButtonText || t('actions.continue')"
            responsive
            v-bind="{
              ...data?.style?.submitBtnProps,
            }"
            @click="onConfirm"
          />
        </VRow>
      </div>
    </VCard>
  </VDialog>
</template>
